import { TopChapter, ChapterItem } from '../types';

export const REHEARSAL_CHAPTERS: ChapterItem[] = [
  { title: '宇治拾遺物語・十訓抄', testIdentifier: 'ujisyui',     lessons: ['児のそら寝', '絵仏師良秀', '大江山'] },
  { title: '徒然草',               testIdentifier: 'tureduregusa', lessons: ['つれづれなるままに'] },
  { title: '伊勢物語',             testIdentifier: 'ise',          lessons: ['芥川', '東下り', '東下り(難)'] },
  { title: '土佐日記',             testIdentifier: 'tosa',         lessons: ['門出', '門出(難)'] },
];

export const TOP_CHAPTERS: TopChapter[] = [
  {
    id: 'spelling',
    title: '歴史的仮名遣い',
    type: 'flat',
    testIdentifier: 'formerSpell',
    lessons: ['「む」の発音', '古文のハ行', '古文のワ行', '「くゎ」「ぐゎ」の発音', '二重母音(1)', '二重母音(2)', '二重母音(3)', 'チェックテスト'],
  },
  {
    id: 'verb',
    title: '用言(動詞・形容詞・形容動詞)',
    type: 'nested',
    subChapters: [
      { title: '基本形(1)',   testIdentifier: 'basicWordFirst',  lessons: ['動詞の基本形','歴史的仮名遣い','歴史的仮名遣い(2)','上二段活用','下二段活用','下二段活用(2)','チェックテスト'] },
      { title: '基本形(2)',   testIdentifier: 'basicWordSecond', lessons: ['上一段活用(1)','上一段活用(2)','下一段活用','カ行変格活用','サ行変格活用','ナ行変格活用','ラ行変格活用','まぎらわしい動詞','チェックテスト'] },
      { title: '活用の行',   testIdentifier: 'verbColumn',      lessons: ['動詞の活用行','上二段・下二段活用の行','上一段・下一段活用の行','カ・サ・ナ・ラ変格活用の行','紛らわしい動詞の行','チェックテスト'] },
      { title: '活用の種類', testIdentifier: 'verbType',        lessons: ['活用の種類','四段活用','上二段活用','下二段活用','振り返り','上一段活用','下一段活用','まぎらわしい動詞(1)','まぎらわしい動詞(2)','チェックテスト'] },
      { title: '活用形(1)',  testIdentifier: 'verbFormFirst',   lessons: ['活用形とは','活用形の判別','活用表','活用形','四段活用の活用形','上二段活用の活用形','下二段活用の活用形','復習','チェックテスト'] },
      { title: '活用形(2)',  testIdentifier: 'verbFormSecond',  lessons: ['上一段活用の活用形','下一段活用の活用形','復習(1)','カ行変格活用の活用形','サ行変格活用の活用形','ナ行変格活用の活用形','ラ行変格活用の活用形','復習(2)','応用問題','チェックテスト'] },
      { title: '形容詞',     testIdentifier: 'adjective',       lessons: ['現代の形容詞','古文の形容詞の基本形','形容詞の活用の種類','ク活用の活用形','シク活用の活用形','チェックテスト'] },
      { title: '形容動詞',   testIdentifier: 'adjectival',      lessons: ['現代の形容動詞','古文の形容動詞の基本形','形容動詞の活用の種類','ナリ活用の活用形','タリ活用の活用形','チェックテスト'] },
    ],
  },
  {
    id: 'auxiliaryVerb',
    title: '助動詞',
    type: 'nested',
    subChapters: [
      { title: '「ず」「けり」「き」',            testIdentifier: 'primer',     lessons: ['「ず」の意味と現代語訳','「ず」の活用形','「ず」の接続','「けり」の意味と現代語訳','「けり」の活用形と接続','「き」の活用形と接続','「き」の意味と現代語訳','チェックテスト'] },
      { title: '「つ」「ぬ」「たり」「り」',      testIdentifier: 'completion', lessons: ['「つ」「ぬ」の意味と接続','「つ」「ぬ」の出題パターン','「たり」「り」の意味','「たり」「り」の接続','「ぬ」の識別','チェックテスト'] },
      { title: '「む(むず)」「べし」',            testIdentifier: 'guessA',     lessons: ['「む」「むず」の意味','「む」「むず」の意味(2)','「む」「むず」の撥音便「ん」','「べし」の意味','「べし」の意味(2)','「む」「べし」の接続','チェックテスト'] },
      { title: '「じ」「まじ」「らむ」「けむ」',  testIdentifier: 'guessB',     lessons: ['「じ」の意味','「まじ」の意味','「じ」「まじ」の接続','「らむ」「けむ」の意味','「らむ」「けむ」の接続','チェックテスト'] },
      { title: '「る」「らる」「す(さす)」「しむ」', testIdentifier: 'respect', lessons: ['「る」「らる」の意味','「す(さす)」「しむ」の意味','「る」「らる」「す(さす)」「しむ」接続','「る」の識別','チェックテスト'] },
      { title: 'その他の助動詞',                  testIdentifier: 'other',      lessons: ['「らし」「なり」「めり」','「なり」「たり」','「なり」「たり」の識別','「まし」','「ごとし」','「まほし」「たし」','チェックテスト'] },
    ],
  },
  {
    id: 'honorifics',
    title: '敬語',
    type: 'flat',
    testIdentifier: 'honorifics',
    lessons: ['現代敬語の復習(1)','現代敬語の復習(2)','古文の敬語の種類','敬語と主語','敬意表現の方向性','絶対敬語','二方面への敬語','チェックテスト'],
  },
  {
    id: 'rehearsal',
    title: '定期テスト予想問題',
    type: 'rehearsal',
    subChapters: REHEARSAL_CHAPTERS,
  },
];
